// frontend/src/components/celebration-chat/CreationSuccessCard.tsx
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight, MessageSquare } from 'lucide-react';

interface CreationSuccessCardProps {
  celebrationId: number;
  title: string;
  onNavigate: (celebrationId: number) => void;
  eventsCreated?: number;
  activitiesCreated?: number;
  servicesShortlisted?: number;
  conversationLogId?: number;
}

export const CreationSuccessCard: React.FC<CreationSuccessCardProps> = ({
  celebrationId,
  title,
  onNavigate,
  eventsCreated,
  activitiesCreated,
  servicesShortlisted,
  conversationLogId,
}) => {
  const hasCounts =
    (eventsCreated !== undefined && eventsCreated > 0) ||
    (activitiesCreated !== undefined && activitiesCreated > 0) ||
    (servicesShortlisted !== undefined && servicesShortlisted > 0);

  return (
    <Card className="border-green-200 bg-green-50 dark:bg-green-950/20 dark:border-green-800 max-w-md">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2 text-green-700 dark:text-green-400">
          <CheckCircle className="h-5 w-5" />
          Celebration Created!
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          <strong>{title}</strong> has been created successfully.
          {hasCounts && (
            <>
              {' '}It includes{' '}
              {eventsCreated ? `${eventsCreated} event${eventsCreated > 1 ? 's' : ''}` : ''}
              {eventsCreated && activitiesCreated ? ' and ' : ''}
              {activitiesCreated ? `${activitiesCreated} activit${activitiesCreated > 1 ? 'ies' : 'y'}` : ''}
              {(eventsCreated || activitiesCreated) && servicesShortlisted ? ', plus ' : ''}
              {servicesShortlisted ? `${servicesShortlisted} service${servicesShortlisted > 1 ? 's' : ''}` : ''}
              {' '}from your template.
            </>
          )}
          {!hasCounts && ' You can now set up tags, events, and activities.'}
        </p>
        {conversationLogId && (
          <div className="flex items-center gap-1.5 text-xs text-muted-foreground bg-muted/50 rounded px-2 py-1">
            <MessageSquare className="h-3 w-3" />
            <span>Conversation ID: <strong>{conversationLogId}</strong></span>
          </div>
        )}
        <Button
          onClick={() => onNavigate(celebrationId)}
          className="w-full"
        >
          View Celebration
          <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </CardContent>
    </Card>
  );
};
